












import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class ChoiceCheckDialog extends Vue {
  private visible = false;
  private URLPath: any = '';
  private path: any = '';
  private imgShow: any = true;

  private async showDialog(path: any) {
    this.imgShow = true;
    this.URLPath = publishObjectPath.imgPathWater;
    this.path = path;
    if (this.path.indexOf('.pdf') > -1 || this.path.indexOf('.PDF') > -1 || this.path.indexOf('.txt') > -1 || this.path.indexOf('.TXT') > -1) {
      this.imgShow = false;
    } else {
      this.imgShow = true;
    }
    this.visible = true;
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.visible = false;
  }
}
